import ApiService from '@/common/api/api.service';

let apiBasePath = 'EstoqueMovimento';

const EstoqueMovimentoService = {
    async obterPorFiltro(parametros) {
        let { data } = await ApiService.get(
            `${apiBasePath}/por-filtro-paginado`,  {params: {...parametros}}
        );
        return data;
    }
};

export default EstoqueMovimentoService;

